import { baseApi } from "@/config/http-common";

class DocumentConstructorDataService {
  getAll(params?: Record<string, unknown>): Promise<any> {
    return baseApi.get("/documents/document-constructor/list", { params });
  }

  get(id: any): Promise<any> {
    return baseApi.get(`/documents/document-constructor/view/${id}`);
  }

  create(data: any): Promise<any> {
    return baseApi.post("/documents/document-constructor/create", data);
  }

  update(id: any, data: any): Promise<any> {
    return baseApi.put(`/documents/document-constructor/update/${id}`, data);
  }

  delete(id: string, coordinatorId?: string): Promise<any> {
    return baseApi.delete(`/documents/document-constructor/delete/${id}`, {
      params: coordinatorId != null ? { coordinatorId } : undefined,
    });
  }
  getCompanies(): Promise<any> {
    return baseApi.get(`/documents/document-constructor/sub-data/companies`);
  }

  getRoles(): Promise<any> {
    return baseApi.get("/users/users/sub-data/roles");
  }

  getJobs(): Promise<any> {
    return baseApi.get("/documents/document-constructor/sub-data/jobs");
  }

  getUsers(): Promise<any> {
    return baseApi.get(`/documents/document-constructor/sub-data/users`);
  }

  getTemplates(params?: { page?: number }): Promise<any> {
    return baseApi.get(
      `/documents/document-constructor/sub-data/process-template`,
      { params }
    );
  }

  getParamsTemplate(): Promise<any> {
    return baseApi.get("/documents/document-constructor/sub-data/params");
  }

  getScopes(): Promise<any> {
    return baseApi.get("/documents/document-constructor/sub-data/scopes");
  }

  getCounterpartySelectionModes(): Promise<any> {
    return baseApi.get(
      "/documents/document-constructor/sub-data/counterparty-selection-modes"
    );
  }

  getEsedoDocumentTypes(page = 0): Promise<any> {
    return baseApi.get(
      "/documents/document-constructor/sub-data/esedo-document-types",
      { params: { page } }
    );
  }

  getEsedoQuestionNatures(page = 0): Promise<any> {
    return baseApi.get(
      "/documents/document-constructor/sub-data/esedo-question-natures",
      { params: { page } }
    );
  }

  getEsedoPartners(page = 0): Promise<any> {
    return baseApi.get(
      "/documents/document-constructor/sub-data/esedo-partners",
      { params: { page } }
    );
  }
}

export default new DocumentConstructorDataService();
